// tslint:disable:no-empty-interface
// tslint:disable:max-line-length
// tslint:disable: no-use-before-declare
/********************************************************************************/
/*                      TCI Applications Monitoring request/response                  */
/********************************************************************************/
import {
    AbstractTCITenantComponentOptions,
    ITCIApplicationRequest,
    ITCIApplicationResponse,
    ITCIOptionType,
    ITCITenantComponentOptions,
    ITCITenantServiceProvider,
    TCITenantSelectorType
} from "./tci-tenant";
import { Observable, Subject } from "rxjs";
import { TCITenantAppType } from "./tci-application";
import { strEnum } from "../../types";

/**
 * Enumeration of TCI app detail env menu types
 */
export const TCI_APP_DETAIL_MONITORING_MENU_TYPE: ITCIOptionType<string> = {
    MAIN_MENU: "main",
    HAMBURGER_MENU: "hamburger"
};

export type TCI_APP_DETAIL_MONITORING_MENU_TYPE = keyof typeof TCI_APP_DETAIL_MONITORING_MENU_TYPE;

export class TCITenantAppDetailMonitoring
    extends AbstractTCITenantComponentOptions<TCI_APP_DETAIL_MONITORING_MENU_TYPE>
    implements ITCITenantComponentOptions<TCI_APP_DETAIL_MONITORING_MENU_TYPE> {

    public static TCI_MENU_APP_MONITORING_TRIGGERS = new TCITenantAppDetailMonitoring(
        "Triggers",
        TCITenantSelectorType.TCI_MENU_APP_MONITORING_TRIGGERS, 1, "appmontriggers", [
        TCITenantAppType.flogo
    ], TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU);

    public static TCI_MENU_APP_MONITORING_FLOWS = new TCITenantAppDetailMonitoring(
        "Flows",
        TCITenantSelectorType.TCI_MENU_APP_MONITORING_FLOWS, 2, "appmonflows", [
        TCITenantAppType.flogo
    ], TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU);

    public static TCI_MENU_APP_MONITORING_PROCESSES = new TCITenantAppDetailMonitoring(
        "Processes",
        TCITenantSelectorType.TCI_MENU_APP_MONITORING_PROCESSES, 3, "appmonprocesses", [
        TCITenantAppType.bw
    ], TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU);

    public static TCI_MENU_APP_MONITORING_RESOURCE_METRICS = new TCITenantAppDetailMonitoring(
        "Resource Metrics",
        TCITenantSelectorType.TCI_MENU_APP_MONITORING_RESOURCE_METRICS, 4, "appmonresourcemetrics", [
        TCITenantAppType.bw,
        TCITenantAppType.node,
        TCITenantAppType.flogo,
    ], TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU);

    private static allItems = [
        TCITenantAppDetailMonitoring.TCI_MENU_APP_MONITORING_TRIGGERS,
        TCITenantAppDetailMonitoring.TCI_MENU_APP_MONITORING_FLOWS,
        TCITenantAppDetailMonitoring.TCI_MENU_APP_MONITORING_PROCESSES,
        TCITenantAppDetailMonitoring.TCI_MENU_APP_MONITORING_RESOURCE_METRICS
    ];

    /**
     * Gets All menu items
     * @param menuType
     * @return @ITCITenantMenu[]
     */
    public static getAllMenuItems(menuType?: TCI_APP_DETAIL_MONITORING_MENU_TYPE): ITCITenantComponentOptions<TCI_APP_DETAIL_MONITORING_MENU_TYPE>[] {
        if (menuType) {
            return TCITenantAppDetailMonitoring.allItems.filter((v) => {
                return v.getOptionType() === menuType;
            });
        }
        return TCITenantAppDetailMonitoring.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param routeId
     * @param tenantAppTypes
     * @param menuType
     */
    constructor(menuOption: string,
        componentSelectorType: TCITenantSelectorType,
        position: number,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        menuType: TCI_APP_DETAIL_MONITORING_MENU_TYPE = TCI_APP_DETAIL_MONITORING_MENU_TYPE.MAIN_MENU) {
        super(menuOption, componentSelectorType, position, menuType, routeId, tenantAppTypes, null);
    }
}

export const enum TCIApplicationMonitoringMode {
    MODE_APP_LIST,
    MODE_APP_DETAILS
}


/**
 * TCI_APP_MONITORING_REQUEST_TYPE
 * @type {{[K in string]: K}}
 */
export const TCI_APP_MONITORING_REQUEST_TYPE = strEnum([

    // Metrics UI channels
    "APP_LIST_STATE_SUMMARY",  // Good, Warning, Error, Stopped pie chart
    "APP_LIST_TENANT_SUMMARY", // BW,Flogo,Scribe,Node
    "APP_LIST_TOP_EXECUTIONS", // Top Executions
    "APP_LIST_PEEK_INFO", // Tenant component, Base component for TCI
    "APP_RESOURCE_UTILIZATION", // App resource utilization graph
    "APP_RESOURCE_CPU", // App cpu utilization
    "APP_RESOURCE_MEMORY", // App memory utilization
    "APP_INSTANCE_LIST", // App instance update notifications
    "APP_INSTANCE_SELECTED" // App instance choosen
]);
export type TCI_APP_MONITORING_REQUEST_TYPE = keyof typeof TCI_APP_MONITORING_REQUEST_TYPE;

interface ITCIAppMonitoringMemoryUtilization {
}

interface ITCIAppMonitoringCpuUtilization {
}

interface ITCIAppMonitoringResourceUtilization {
}

interface ITCIAppMonitoringPeekInfo {
}

interface ITCIAppMonitoringTopExecutions {
}

interface ITCIAppMonitoringTenantSummary {
}

interface ITCIAppMonitoringStateSummary {
}

export interface ITCIMonitoringInstance {
    key: string;
    label: string;
    ip?: string;
}

export interface ITCIMonitoringInstances {
    [key: string]: ITCIMonitoringInstance;
}

export interface ITCIApplicationMonitoring {
    /**
     * instance id key: label
     */
    instances?: ITCIMonitoringInstances;
    /**
     * selected instance being observed
     */
    selectedInstance?: ITCIMonitoringInstance;
    /**
     * APP_LIST_STATE_SUMMARY: header state data structure
     */
    headerState?: ITCIAppMonitoringStateSummary;
    /**
     * APP_LIST_TENANT_SUMMARY: tenant summary data structure
     */
    tenantSummary?: ITCIAppMonitoringTenantSummary;
    /**
     * APP_LIST_TOP_EXECUTIONS: top executions data structure
     */
    topExecutions?: ITCIAppMonitoringTopExecutions;
    /**
     * APP_LIST_PEEK_INFO: peek info data structure
     */
    peekInfo?: ITCIAppMonitoringPeekInfo;
    /**
     * APP_RESOURCE_UTILIZATION: resource utilization data structure
     */
    resourceUtilization?: ITCIAppMonitoringResourceUtilization;
    /**
     * APP_RESOURCE_CPU: cpu utilization data structure
     */
    cpuUtilization?: ITCIAppMonitoringCpuUtilization;
    /**
     * APP_RESOURCE_MEMORY: memory utilization data structure
     */
    memoryUtilization?: ITCIAppMonitoringMemoryUtilization;
}

export interface ITCIApplicationsMonitoringRequest extends ITCIApplicationRequest {
    applicationType?: string;
    request_type: TCI_APP_MONITORING_REQUEST_TYPE;
}

export interface ITCIApplicationMonitoringResponse extends ITCIApplicationResponse {
    msg: string;
    success: boolean;
    request_type: TCI_APP_MONITORING_REQUEST_TYPE;
    result: ITCIApplicationMonitoring | any;
}

/**
 * interface Application Monitoring Provider
 */
export interface ITCIApplicationMonitoringProvider extends ITCITenantServiceProvider {
    /**
     * Start  subscription
     * @param input
     */
    startAppMonitoringSubscription(input: ITCIApplicationsMonitoringRequest): Observable<boolean>;

    /**
     * Stop  subscription
     * @param input
     */
    stopAppMonitoringSubscription(input: ITCIApplicationsMonitoringRequest): Observable<boolean>;

    /**
     * get Monitoring subject by type
     * @param type
     */
    getAppMonitoringSubject(type: TCI_APP_MONITORING_REQUEST_TYPE): Subject<ITCIApplicationMonitoringResponse>;

    /**
     * UI check to show Metrics Collection Dynamic component
     * Tenants can put their metrics toggles in this dynamic component
     * The tenants need to maintain state of the toggles on the tenant implementation
     * of the provider and TCI base code will not maintain them as it is not aware
     * of how many and which toggles
     * @param input
     */
    canShowMetricsCollection(input: ITCIApplicationsMonitoringRequest): Observable<boolean>;

    /**
     * UI check to show the app instance selector drop down
     * for a given app id
     */
    canShowInstanceSelector(input: ITCIApplicationsMonitoringRequest): Observable<boolean>;

    /**
     * Initial data for app instances to populate the InstanceSelector, dynamically updated
     * later using monitoring subscription
     * @param input
     */
    getAppInstances(input: ITCIApplicationsMonitoringRequest): Observable<ITCIApplicationMonitoringResponse>;

    /**
     * Initialize the observation of an instance
     * @param instance
     */
    setSelectedInstance(instance: ITCIMonitoringInstance): void;

    /**
     * Return the intance that is being observated
     */
    getSelectedInstance(): Observable<ITCIMonitoringInstance>;

    /**
     * Perform refresh for data based on TCI_APP_MONITORING_REQUEST_TYPE
     * @param input
     */
    refresh(input: ITCIApplicationsMonitoringRequest): Observable<ITCIApplicationMonitoringResponse>;
}

export interface ITCITenantAppDetailMonitoringRanges {
    id: number;
    label: string;
    range: number;
    step: number;
}

/**
 * Allowed ranges for application details
 */
export class TCITenantAppDetailMonitoringRanges implements ITCITenantAppDetailMonitoringRanges {
    static last2hrs = new TCITenantAppDetailMonitoringRanges(0, "Last 2 hrs", 120, 60);
    static last4hrs = new TCITenantAppDetailMonitoringRanges(1, "Last 4 hrs", 240, 120);
    static last8hrs = new TCITenantAppDetailMonitoringRanges(2, "Last 8 hrs", 480, 180);
    static last12hrs = new TCITenantAppDetailMonitoringRanges(3, "Last 12 hrs", 720, 240);
    static last24hrs = new TCITenantAppDetailMonitoringRanges(4, "Last 24 hrs", 1440, 480);

    constructor(public id: number, public label: string, public range: number, public step: number) { }

    static getAllRanges(): TCITenantAppDetailMonitoringRanges[] {
        return [
            TCITenantAppDetailMonitoringRanges.last2hrs,
            TCITenantAppDetailMonitoringRanges.last4hrs,
            TCITenantAppDetailMonitoringRanges.last8hrs,
            TCITenantAppDetailMonitoringRanges.last12hrs,
            TCITenantAppDetailMonitoringRanges.last24hrs
        ];
    }

    static getRangeById(id: number): TCITenantAppDetailMonitoringRanges {
        return TCITenantAppDetailMonitoringRanges.getAllRanges()
            .find(opt => opt.id === id);
    }

    static getDefault(): TCITenantAppDetailMonitoringRanges {
        return TCITenantAppDetailMonitoringRanges.last2hrs;
    }
}

export interface ITCIApplicationPodInfo {
    podIP: string;
    podID: string;
}

export interface ITCIApplicationInstanceInfo {
    /**
     * CIC2 prop - Application id
     */
    appId?: string;
    /**
     * CIC2 prop - Subscription id
     */
    subscriptionId?: string;
    /**
     * CIC2 prop - Namespace
     */
    namespace?: string;
    /**
     * CIC2 prop - Application type
     */
    appType?: string;
    /**
     * CIC2 prop - Pod info (ip and id)
     */
    pods?: ITCIApplicationPodInfo[];
    /**
     * CIC1 prop - Container id's
     */
    instances?: string[];
}
